<script setup lang="ts">
import {ref} from "vue";
import AddLiveSectionForm from "components/dialog/live/inner/AddLiveSectionForm.vue";
import {AddLiveSection} from "@/types";

const addLiveSectionForm = ref<InstanceType<typeof AddLiveSectionForm>>();
const visible = ref(false);
const isFake = ref(false);

const show = (_isFake: boolean) => {
  isFake.value = _isFake;
  visible.value = true;
}

const hide = () => {
  visible.value = false;
}

const onSubmit = (form: AddLiveSection) => {
  emit("onSubmit", form);
}

const onClose = () => {
  addLiveSectionForm.value?.reset()
}

const emit = defineEmits(['onSubmit'])

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog
      @close="onClose"
      title="新增章节" width="50rem"
      align-center v-model="visible" :close-on-click-modal="false">
    <add-live-section-form
        ref="addLiveSectionForm"
        :is_fake="isFake" @on-submit="onSubmit" @on-close="hide"/>
  </el-dialog>
</template>

<style scoped>
</style>
